import {
  blueColorScheme,
  ButtonSVGProps,
  ButtonSVGType,
  normalLongColorScheme
} from '@src/constants/variant'
import { useMemo } from 'react'

const LongButtonSVG = ({ style }: ButtonSVGProps) => {
  const colorScheme = useMemo(() => {
    if (style === ButtonSVGType.Blue) {
      return blueColorScheme
    }

    return normalLongColorScheme
  }, [style])

  return (
    <svg
      className='blue'
      width='220'
      height='43'
      viewBox='0 0 220 43'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        id={style === ButtonSVGType.Blue ? '' : 'background'}
        fillRule={style === ButtonSVGType.Blue ? 'evenodd' : undefined}
        clipRule={style === ButtonSVGType.Blue ? 'evenodd' : undefined}
        d='M7.62382 7H8.62382V6V1L212.465 1V6V7H213.465H219V36H213.465H212.465V37V42H8.62382V37V36H7.62382H1L1 7H7.62382Z'
        fill={colorScheme.pathFill}
        stroke={colorScheme.pathStroke}
        strokeWidth='2'
      />
      <rect
        x='10'
        y='8'
        width='6'
        height='6'
        fill={colorScheme.smallRectFill}
        fillOpacity='0.5'
      />
      <rect
        x='10'
        y='29'
        width='6'
        height='6'
        fill={colorScheme.smallRectFill}
        fillOpacity='0.5'
      />
      <rect
        x='14.4142'
        y='21'
        width='10'
        height='10'
        transform='rotate(-45 14.4142 21)'
        fill={colorScheme.rectFill}
        stroke={colorScheme.rectStroke}
        strokeWidth='2'
      />
      <rect
        x='205'
        y='8'
        width='6'
        height='6'
        fill={colorScheme.smallRectFill}
        fillOpacity='0.5'
      />
      <rect
        x='205'
        y='29'
        width='6'
        height='6'
        fill={colorScheme.smallRectFill}
        fillOpacity='0.5'
      />
      <rect
        x='192.414'
        y='21'
        width='10'
        height='10'
        transform='rotate(-45 192.414 21)'
        fill={colorScheme.rectFill}
        stroke={colorScheme.rectStroke}
        strokeWidth='2'
      />
    </svg>
  )
}

export default LongButtonSVG
